export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="shrink-0"
  >
    <circle cx="20" cy="20" r="18" fill="#C85A32" fillOpacity="0.12" stroke="#C85A32" strokeWidth="1.5" />
    <path d="M20 8C20 8 13 14 13 22C13 25.866 16.134 29 20 29C23.866 29 27 25.866 27 22C27 14 20 8 20 8Z" fill="#2D4A3E" />
    <path d="M20 12V26M20 16L16 13M20 19L24 16M20 22L16 19M20 25L24 22" stroke="#E5982B" strokeWidth="1.75" strokeLinecap="round" />
    <circle cx="20" cy="9" r="2" fill="#E5982B" />
  </svg>
);

export const LogoFull = ({ compact = false, testId = "brand-logo" }) => (
  <div className="flex items-center gap-3" data-testid={testId}>
    <LogoMark size={compact ? 34 : 40} />
    <div className="leading-none">
      <p className="font-display text-lg sm:text-xl font-bold tracking-wide text-ragi-dark">
        KANDULA
      </p>
      <p className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.28em] text-terracotta">
        Home Foods
      </p>
    </div>
  </div>
);
